module.exports = __webpack_public_path__ + "static/media/beforeMidDay.6c255b22.png";